import type { ReportHistoryStatusUnionType } from '@api';
import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { getReportHistoryStatusColor } from './helpers';

type ReportHistoryStatusBadgePropsType = {
  status: ReportHistoryStatusUnionType;
};

export const ReportHistoryStatusBadge: React.FC<
  ReportHistoryStatusBadgePropsType
> = ({ status }) => {
  const { t } = useTranslation();
  const { backgroundColor, textColor } = getReportHistoryStatusColor(status);

  return (
    <Badge color={backgroundColor} style={{ color: textColor }}>
      {t(`REPORTS.ENUMS.STATUS.${status}`)}
    </Badge>
  );
};
